<template>
  <div class="container sv sv044">

    <breadcrumb-group :items="breadcrumbItems"/>

    <heading-one>auサービスでもっとおトクに！</heading-one>

    <p class="_mb-md-60">auユーザーならもっとおトク！日々の暮らしをちょっとよくするおトクな情報をお知らせします。</p>

    <section id="section_01">

      <card-groups class="-image-top-list">
        <card-box router-name="sv016" class="-image-top">
          <card-header>
            <card-image class="-orange"><img src="@/assets/images/sv/sv016/thumb.jpg" class="img-fluid" alt=""></card-image>
            <h3 class="heading">Pontaポイントでスマートな暮らしを！</h3>
          </card-header>
          <card-body>お借り入れ方法は、au PAY 残高へのチャージがおすすめ！Pontaポイントをためて賢く暮らそう！</card-body>
        </card-box>
        <card-box router-name="sv013" class="-image-top">
          <card-header>
            <card-image class="-orange"><img src="@/assets/images/sv/sv013/thumb.jpg" class="img-fluid" alt=""></card-image>
            <h3 class="heading">携帯電話の料金を見直しておトクに節約！</h3>
          </card-header>
          <card-body>お給料日前は毎月ピンチ…節約を考えるなら、まずは「固定費」を見直してみよう。</card-body>
        </card-box>
        <card-box router-name="sv014" class="-image-top">
          <card-header>
            <card-image class="-orange"><img src="@/assets/images/sv/sv014/thumb.jpg" class="img-fluid" alt=""></card-image>
            <h3 class="heading">auでんきでスマートに省エネ！Pontaポイントもたまる！</h3>
          </card-header>
          <card-body>auでんきに乗り換えれば、au スマホやau ひかりとセットで毎月の電気利用量に応じてPontaポイントがたまる！アプリの活用で省エネも。</card-body>
        </card-box>
      </card-groups>

      <btngroup-single class="-margin-lg">
        <btn-main class="-normal -lg" routerName="sv003">知っておきたい！ローンについてへ戻る</btn-main>
      </btngroup-single>
      <cv-box class="_mb-120 _mb-sm-60"/>
    </section>

  </div><!-- container -->
</template>

<script>
import HeadingOne from '../components/heading/HeadingOne'
import BtnMain from '../components/button/BtnMain'
import BtngroupSingle from '../components/button/BtngroupSingle'
import CardBox from '../components/card/CardBox'
import CardHeader from '../components/card/CardHeader'
import CardBody from '../components/card/CardBody'
import CardGroups from '../components/card/CardGroups'
import CardImage from '../components/card/CardImage'
import CvBox from '../components/box/CvBox'

export default {
  name: 'Sv-044',
  metaInfo: {
    title: 'auサービスでもっとおトクに！｜知っておきたい！ローンについて',
    meta: [
      {name: 'description', content: 'auユーザーならこんなメリットも！auユーザーがおトクに生活できる節約術などを紹介します。au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。'},
      {name: 'keywords', content: 'au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,auサービス,おトク'}
    ]
  },
  components: {
    CvBox,
    BtnMain,
    BtngroupSingle,
    CardBody,
    CardImage,
    CardHeader,
    CardBox,
    CardGroups,
    HeadingOne
  },
  data () {
    return {
      breadcrumbItems: [{
        text: 'トップ',
        routerName: 'root'
      },
      {
        text: '知っておきたい！ローンについて',
        routerName: 'sv003'
      },
      {
        text: 'auサービスでもっとおトクに！',
        active: true
      }
      ]
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Sv044.vue